import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import { Box, Button, ButtonProps, Menu, MenuItem, Typography } from '@mui/material';
import { Link } from 'components/common/Link';
import React, { useState } from 'react';
import useUser from 'stores/useCustomer';
import { colors } from 'styles/theme/colors';
import { useServerTranslation } from 'hooks/useServerTranslation';
import useCustomerActions from '../hooks/useCustomerActions';

function LoginButtonText() {
    const customer = useUser((state) => state.user);
    const { t } = useServerTranslation();

    if (customer) {
        const [firstName = customer.name] = customer.name.split(' ');

        return firstName || customer.name;
    }

    return t('menu.log-in');
}

type MyAccountButtonProps = ButtonProps;

export default function MyAccountButton({ ...buttonProps }: MyAccountButtonProps) {
    const { t } = useServerTranslation();
    const { clickMyAccount, clickLogOut } = useCustomerActions();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <Button
                variant="black"
                size="small"
                LinkComponent={Link}
                {...buttonProps}
                onClick={handleClick}
                sx={{
                    borderRadius: { xs: '50%', md: '2px' },
                    padding: '6px',
                    '&:hover': { backgroundColor: { md: colors.white }, color: { md: colors.pink2 } },
                }}
            >
                <Box sx={{ display: { xs: 'none', md: 'inline-block', marginRight: '4px' } }}>
                    <LoginButtonText />
                </Box>
                <PersonOutlineIcon />
            </Button>
            <Menu
                open={open}
                onClose={handleClose}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
            >
                <MenuItem onClick={clickMyAccount}>{t('menu.my-account')}</MenuItem>
                <MenuItem onClick={clickLogOut}>{t('menu.log-out')}</MenuItem>
            </Menu>
        </>
    );
}
